module.exports = __webpack_public_path__ + "static/media/happy-students.7f9fab34.png";